import { useMobile } from 'common-nextjs';
import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from '~/components/Icons/ChevronIcons';
import { useSession } from '~/contexts/SessionContext';
import useUserConfiguration from '~/hooks/useUserConfiguration';

interface Props {
  description?: React.ReactNode;
  title?: string;
}

const ListFlowSection: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  description,
  title,
}) => {
  const mobile = useMobile();
  const { loggedIn } = useSession();
  const { data: userConfiguration } = useUserConfiguration();
  const [expanded, setExpanded] = useState(!loggedIn);

  // If you're not logged in, or it's your first listing, expand help sections
  useEffect(() => {
    if (
      (userConfiguration?.properties &&
        userConfiguration.properties.list_count == null) ||
      userConfiguration?.properties?.list_count === 0
    ) {
      setExpanded(true);
    }
  }, [userConfiguration]);

  return (
    <section className="grid md:grid-cols-6 md:gap-4">
      <div className="md:col-span-4">
        {title && (
          <div className="mb-2 mt-4 flex items-center justify-between font-normal md:mb-4 md:mt-6">
            <h2 className="text-lg font-semibold uppercase">{title}</h2>

            {mobile && !!description && (
              <button onClick={() => setExpanded(e => !e)}>
                {expanded ? <ChevronUp /> : <ChevronDown />}
              </button>
            )}
          </div>
        )}

        {mobile && expanded && !!description && (
          <div className="mb-6">{description}</div>
        )}

        {children}
      </div>

      {!mobile && !!description && (
        <div className="mt-6 md:col-span-2">{description}</div>
      )}
    </section>
  );
};

export default ListFlowSection;
